module.exports = __webpack_public_path__ + "static/ramesh-0ce9710c735fd30104ad26e6cc4f212f.png";